// extracted by mini-css-extract-plugin
module.exports = {"box-header":"_92591a","box-header__children":"b232fe"};